import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
	ContactForm,
	ContactFormResponse,
	QuestionnaireTemplatesPreviews,
	ResponseActions,
	Template,
	TemplateResponse
} from '@web-components/settings/settings.model';
import { catchError, map } from 'rxjs/operators';
import { PageRequest, ServerDataResponse } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';

@Injectable()
export class SettingsDataService {
	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	getContactFormPreviews(pageRequest: PageRequest): Observable<ContactForm> {
		const url = '/api/user/v1/contactform/preview';
		return this.http.post(url, pageRequest).pipe(
			map((res: ServerDataResponse<ContactForm>): ContactForm => res.data),
			catchError((error): Observable<null> =>
				this.messageService.catchErrorFromBackend(error)
			)
		);
	}

	duplicateContactForm(url: string, newName: string): Observable<Template> {
		return this.http.post(url, { name: newName }).pipe(
			map((res: TemplateResponse): Template => res.data),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	deleteContactForm(url: string): Observable<Object> {
		return this.http
			.delete(url)
			.pipe(
				catchError(error => this.messageService.catchErrorFromBackend(error))
			);
	}

	getNewTemplateURL(url: string, requestBody = {}) {
		return this.http.post(url, requestBody).pipe(
			map(
				(data: ServerDataResponse<ResponseActions>): ResponseActions =>
					data.data
			),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	getQuestionnaireTemplatesPreviews(
		pageRequest: PageRequest
	): Observable<QuestionnaireTemplatesPreviews> {
		const url = '/api/user/v2/questionnaire-templates/preview';
		return this.http.post(url, pageRequest).pipe(
			map(
				(
					data: ServerDataResponse<QuestionnaireTemplatesPreviews>
				): QuestionnaireTemplatesPreviews => data.data
			),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	duplicateQuestionnaireTemplate(url: string, newName: string) {
		return this.http.post(url, { name: newName }).pipe(
			map(
				(data: ServerDataResponse<ResponseActions>): ResponseActions =>
					data.data
			),
			catchError(error => this.messageService.catchErrorFromBackend(error))
		);
	}

	deleteQuestionnaireTemplate(url: string): Observable<Object> {
		return this.http
			.delete(url)
			.pipe(
				catchError(error => this.messageService.catchErrorFromBackend(error))
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/services/settings/contact-form/settings.data.service.ts